'use client';

import SectionWrapper from '@/components/SectionWrapper';
import CustomGrid from '@/components/CustomGrid';
import Icon from '@/components/Icon';
import { useEffect, useState } from 'react';
import { getAllByCategory } from 'lib/services';
import { LuCheck } from 'react-icons/lu'; // Import the function to get services by category

export default function PaintCorrectionServices({ business }) {
  const [paintCorrectionServices, setPaintCorrectionServices] = useState([]);

  useEffect(() => {
    // Fetch paint correction services
    const services = getAllByCategory('paint-correction');
    setPaintCorrectionServices(services);
  }, []);

  return (
    <SectionWrapper id="paint-correction-packages" className="mt-12 space-y-8">
      <h3 className="text-center text-xl font-semibold text-gray-800">
        Choose the Perfect Level of Paint Correction for Your Car
      </h3>
      <p className="text-center text-gray-700">
        At {business.name}, we offer a range of paint correction services
        tailored to meet your specific needs and budget. Whether you're looking
        for a basic touch-up or a complete restoration, our skilled technicians
        will ensure your car's paintwork looks flawless.
      </p>
      <div className="tablet:grid tablet:grid-cols-2 flex flex-col gap-6 px-8">
        {paintCorrectionServices.map((pkg, i) => (
          <div
            key={pkg.slug}
            className="space-y-4 rounded-xl border border-gray-200 bg-gray-100 p-6"
          >
            <div className="space-y-2">
              <p className="text-lg font-semibold text-gray-900">{pkg.title}</p>
              <p className="text-gray-700">{pkg.description}</p>
            </div>
            <hr className="border-gray-300" />
            <div className="space-y-2">
              <p className="text-sm text-gray-800">Starting At</p>
              <p className="text-xl font-bold text-gray-900">{pkg.price}</p>
              <ul className="space-y-1">
                {pkg.exteriorServiceList
                  .concat(pkg.interiorServiceList)
                  .map((feature, j) => (
                    <li
                      key={j}
                      className="flex flex-grow flex-row items-center"
                    >
                      <Icon
                        icon={LuCheck}
                        size={24}
                        className="mr-2 flex-1/12 text-green-600"
                      />
                      <p className="flex-11/12 text-sm text-wrap text-gray-700">
                        {feature}
                      </p>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
}
